<template>
  <div class="container">
    <div style="margin-bottom: 20px;">
      <el-date-picker
        v-model="timeRange"
        type="datetimerange"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        :picker-options="pickerOptions"
        :default-time="['00:00:00', '23:59:59']"
        style="position: relative; top: 1px">
      </el-date-picker>
      <el-button style="margin-left: 10px">导出</el-button>
    </div>

    <el-table :data="itemList" class="table-border" v-loading="loading" header-cell-class-name="table-head">
      <el-table-column type="index" label="序号"></el-table-column>
      <el-table-column label="操作用户" prop="userName" width="100"></el-table-column>
      <el-table-column label="操作时间" prop="createTime" width="150">
        <template #default="{row}">
          {{row.createTime.format('yyyy-MM-dd hh:mm:ss')}}
        </template>
      </el-table-column>
      <el-table-column label="操作API" prop="requestApi" width="160"></el-table-column>
      <el-table-column label="内容" prop="content">
        <template #default="{row}">
          <div v-html="row.content.replace(/\n/g, '<br />')"></div>
        </template>
      </el-table-column>
    </el-table>

    <div style="text-align: center; margin-top: 10px">
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="page.current"
        :page-sizes="[10, 20, 50]"
        :page-size="page.size"
        layout="sizes, total, prev, pager, next, jumper"
        :total="totalCount">
      </el-pagination>
    </div>

  </div>
</template>

<script>
  import { latestLog } from '@/utils/request'

  export default {
    name: 'SystemLog',
    data () {
      return {
        timeRange: null,
        loading: false,
        logItemList: [],
        pickerOptions: {
          disabledDate (time) {
            return time.getLocalDays() > new Date().getLocalDays()
          }
        },
        page: {
          size: 10,
          current: 1
        }
      }
    },
    created () {
      this.loading = true

      latestLog(365).then(response => {
        this.logItemList = response.data
        for (const item of this.logItemList) {
          item.createTime = new Date(item.createTime)
        }
      }).finally(() => {
        this.loading = false
      })
    },
    methods: {
      handleSizeChange (val) {
        this.page.size = val
      },
      handleCurrentChange (val) {
        this.page.current = val
      }
    },
    computed: {
      activeItemList () {
        if (!this.timeRange) return this.logItemList

        return this.logItemList.filter(item => {
          return item.createTime >= this.timeRange[0] && item.createTime <= this.timeRange[1]
        })
      },
      itemList () {
        const begIndex = this.page.size * (this.page.current - 1)
        return this.activeItemList.slice(begIndex, begIndex + this.page.size)
      },
      totalCount () {
        return this.activeItemList.length
      }
    }
  }
</script>

<style lang="scss" scoped>
  /deep/ {
    th {
      height: 50px;
    }
  }
</style>
